/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-void */
import Environments from "../../Environments";
import { CLASS_REQUIRED_EL, CLASS_REQUIRED_GT, CLASS_REQUIRED_CU } from "../../Constants";
import { showErrorMessage } from "./useDialogStateHelper";
import SearchMasterListService, { SearchMasterListResponse, SearchMasterListItem } from "../api/SearchMasterListService";
import { ItemsItem } from "../api/SearchCareerClassListService";

const service = new SearchMasterListService();

const required: Set<ItemsItem> = new Set();

const fetchDivisions = () => {
    if (required.size) {
        return;
    }
    const fetch = async () => {
        if (!Environments.MOCK) {
            try {
                await service.fetchDivisions(
                    (response: SearchMasterListResponse) => {
                        (response.masterList || []).forEach((item: SearchMasterListItem) => {
                            // XXX 現状、SearchCareerClassListPayload.detail専用
                            if (item.code === CLASS_REQUIRED_EL || item.code === CLASS_REQUIRED_GT || item.code === CLASS_REQUIRED_CU) {
                                required.add({ companyId: item.companyId, itemId: item.code });
                            }
                        });
                    },
                    (error: unknown) => {
                        throw error;
                    }
                );
            } catch (error: unknown) {
                showErrorMessage({
                    message: "区分マスタのデータ取得に失敗しました。",
                    error,
                });
            }
        } else {
            required.add({ companyId: "1923", itemId: CLASS_REQUIRED_EL });
            required.add({ companyId: "1923", itemId: CLASS_REQUIRED_GT });
            required.add({ companyId: "1923", itemId: CLASS_REQUIRED_CU });
        }
    };

    void fetch();
};

export const useDivisions = () => {
    fetchDivisions();
    return {
        requiredDivisions: Array.from(required),
    };
};
